<template>
  <div v-if="deliveryOption" class="section-summary-row">
    <span>{{ title }}</span>
    <span class="body-text">
        <span class="icon icon-location-alt"></span>
        <span>
            <b>{{ deliveryOption.name }}</b><br>
            <span v-html="deliveryOption.description"></span><br>
            <span v-if="postnummer">{{ postnummer.dHLPostNummer }}</span>
            <span v-if="pickPost">{{ pickPost.pickPostUserID }}</span>
        </span>
    </span>
    <span class="store-distance"> {{ deliveryOption.distance }}</span>
  </div>
</template>
<script src="./pickup-point-summary.js"/>
